import { render, staticRenderFns } from "./shareRecord.vue?vue&type=template&id=2f280bb5&scoped=true&"
import script from "./shareRecord.vue?vue&type=script&lang=js&"
export * from "./shareRecord.vue?vue&type=script&lang=js&"
import style0 from "./shareRecord.vue?vue&type=style&index=0&id=2f280bb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f280bb5",
  null
  
)

export default component.exports